import { Api } from '../../Api';
import { ListResult } from '../../interfaces';
import { SettingsUserGroupsUserGroupDto, SettingsUserGroupsUserGroupFullDto } from './interfaces';
import { SettingsUserGroupsPostBody, SettingsUserGroupsPutBody } from './body';
import {
    SettingsUserGroupsGetByIdParams,
    SettingsUserGroupsPutByIdParams,
    SettingsUserGroupsDeleteByIdParams,
} from './params';
import { SettingsUserGroupsGetQuery } from './query';
import { getSettingsUserGroupsMockUserGroups, getSettingsUserGroupsMockUserGroup } from './mocks';

export class UserGroups {
    private static _basePath = '/user-groups';

    public static getMethods(parentPath: string) {
        const basePath = `${parentPath}${UserGroups._basePath}`;
        return {
            async get(query: SettingsUserGroupsGetQuery, isMock = false) {
                const path = '/';
                return await Api.get<ListResult<SettingsUserGroupsUserGroupDto>>({
                    path: `${basePath}${path}`,
                    query,
                    isMock,
                    mock: () => getSettingsUserGroupsMockUserGroups({ page: query.page, pageSize: query.recordsCount }),
                    mockName: 'Get User Groups',
                });
            },
            async post(body: SettingsUserGroupsPostBody, isMock: boolean = false) {
                const path = '/';
                return await Api.post<void>({
                    path: `${basePath}${path}`,
                    body,
                    isMock,
                    mock: () => undefined,
                    mockName: 'Post User Group',
                });
            },
            async getById({ id }: SettingsUserGroupsGetByIdParams, isMock: boolean = false) {
                const path = '/';
                return await Api.get<SettingsUserGroupsUserGroupFullDto>({
                    path: `${basePath}${path}${id}`,
                    isMock,
                    mock: getSettingsUserGroupsMockUserGroup,
                    mockName: 'Get User Group By Id',
                });
            },
            async putById(
                { id }: SettingsUserGroupsPutByIdParams,
                body: SettingsUserGroupsPutBody,
                isMock: boolean = false,
            ) {
                const path = '/';
                return await Api.put<void>({
                    path: `${basePath}${path}${id}`,
                    body,
                    isMock,
                    mock: () => undefined,
                    mockName: 'Put User Group By Id',
                });
            },
            async deleteById({ id }: SettingsUserGroupsDeleteByIdParams, isMock: boolean = false) {
                const path = '/';
                return await Api.delete<void>({
                    path: `${basePath}${path}${id}`,
                    isMock,
                    mock: () => undefined,
                    mockName: 'Delete User Group By Id',
                });
            },
        };
    }
}
